export default __webpack_public_path__ + "static/media/empty-basket-image.1744fdc7.png";